import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

// import SignaturesTableHeader from "./SignaturesTableHeader";
import SignaturesTableBody from "./SignaturesTableBody";
// import { Signature } from "entities/UIModel/Signature";
import { useSignatures } from "utils/context/SignaturesContext";
import { IColumn } from "entities/ApiModel/IColumn";

// interface Props {
//   records?: Signature[];
// }

const SignaturesTable =() => { // ({ records = [] }: Props) => {
  const [, { getInitialColumnsDefintion, getColumnsDefinition }] = useSignatures();

  const [columns, setColumns] = useState<IColumn[]>(getInitialColumnsDefintion(false));
  useEffect(() => {
    const getColumns = async () => {
      const { gridColumns } = await getColumnsDefinition();
      setColumns(gridColumns);
    };

    getColumns();
  }, [getColumnsDefinition]);

  return (
    <Box>
      {/* <SignaturesTableHeader /> */}
      <SignaturesTableBody colsConfig={columns} />
    </Box>
  );
};

export default SignaturesTable;
